module.exports = __webpack_public_path__ + "videos/df473822069acdae074504d8310c9b7f.mp4";